<template>
  <div>
    <button class="btn green margin-bottom-10" @click="showAddFormModal = true">Add New</button>
    <base-form-index
      v-if="!loading"
      :show-share-url="true"
      :loading="loading"
      :rows="rows"
      :columns="columns"
      @form-removed="fetchReferralForms"
    />

    <add-form-modal v-if="showAddFormModal"
                    v-on:hide="showAddFormModal = false"
                    :modules="[module]"
                    :preselectedModule="module.key"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import BaseFormIndex from "./BaseFormIndex";
import AddFormModal from "@/components/formbuilder/modals/AddFormModal";

export default {

  components: {
    AddFormModal,
    BaseFormIndex
  },

  data() {
    return {
      showAddFormModal: false,
      formPublish: true,
      formAccounts: [],
      columns: [
        {
          label: 'Name',
          field: 'name',
          html: true,
          filterOptions: {enabled: true}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: true}
        },
        {
          label: 'Status',
          field: 'publish',
          filterOptions: {enabled: true}
        },
        {
          label: 'Created By',
          field: 'created_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Last Modified',
          field: 'last_modification_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
    }
  },

  computed: {
    ...mapGetters({
      loading: 'getReferralFormsLoading',
      forms: 'getReferralForms',
      module: 'getReferralFormModule',
      currentOrganization: 'getOrganization',
    }),

    rows() {
      let rows = [];
      Object.entries(this.forms).forEach(([key, row]) => {

        let date = this.$options.filters.formatDate(row.created_date.date);
        row.created_date = row.user + ' on ' + date;

        if (row.last_modification_date) {
          date = this.$options.filters.formatDate(row.last_modification_date);
        }

        if (row.last_action_user) {
          row.last_modification_date = row.last_action_user + ' on ' + date;
        }

        row.shareUrl = `https://${this.currentOrganization.url}/referral/${row.share_id}`;
        rows.push(row);
      });
      return rows;
    }
  },

  mounted() {
    this.fetchReferralForms();
  },

  methods: {
    ...mapActions([
      'fetchReferralForms'
    ]),
  },
}
</script>



// WEBPACK FOOTER //
// ReferralFormsIndex.vue?750c44a0